export const CART_CREATE_REQUEST = "CART_CREATE_REQUEST";
export const CART_CREATE_SUCCESS = "CART_CREATE_SUCCESS";
export const CART_CREATE_FAIL = "CART_CREATE_FAIL";
export const CART_CREATE_RESET = "CART_CREATE_RESET";

export const CART_UPDATE_REQUEST = "CART_CREATE_REQUEST";
export const CART_UPDATE_SUCCESS = "CART_CREATE_SUCCESS";
export const CART_UPDATE_FAIL = "CART_CREATE_FAIL";

export const CART_DETAILS_REQUEST = "CART_DETAILS_REQUEST";
export const CART_DETAILS_SUCCESS = "CART_DETAILS_SUCCESS";
export const CART_DETAILS_FAIL = "CART_DETAILS_FAIL";

export const CART_DELETE_REQUEST = "CART_DELETE_REQUEST";
export const CART_DELETE_SUCCESS = "CART_DELETE_SUCCESS";
export const CART_DELETE_FAIL = "CART_DELETE_FAIL";

export const CART_REMOVE_REQUEST = "CART_REMOVE_REQUEST";
export const CART_REMOVE_SUCCESS = "CART_REMOVE_SUCCESS";
export const CART_REMOVE_FAIL = "CART_REMOVE_FAIL";

export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_EMPTY = "CART_EMPTY";
export const CART_SAVE_SHIPPING_METHOD = "CART_SAVE_SHIPPING_METHOD";
export const CART_SAVE_SHIPPING_ADDRESS = "CART_SAVE_SHIPPING_ADDRESS";
